import { Badge } from "antd";
import AlertIcon from "../../assets/icons/alert2.svg?react";
import { useAlertCounts } from "../../hooks/useAlertCounts";

/**
 * antd clones a menu item's `icon` element to attach its own
 * `ant-menu-item-icon` class, and that class is what earns the label its 10px
 * icon gap (the `.ant-menu-item-icon + span` rule). Every other nav icon is an
 * svgr component, which spreads unknown props onto its `<svg>`, so the class
 * lands automatically. This one is a hand-written component, so the className
 * arrives as a prop and has to be forwarded — dropping it is what left the
 * Alerts label sitting 10px to the left of every other nav label.
 */
export default function AlertsMenuIcon({
  collapsed,
  className,
}: {
  collapsed: boolean;
  className?: string;
}) {
  const { alertedCount } = useAlertCounts();

  return collapsed ? (
    <div className={`collapsed-alert-menu-icon ${className ?? ""}`.trim()}>
      <Badge
        dot={alertedCount > 0}
        offset={[-5, 4]}
        color="#C275A1"
        className="collapsed-alert-menu-icon__badge text-inherit"
      >
        <AlertIcon className="collapsed-alert-menu-icon__svg" />
      </Badge>
    </div>
  ) : (
    <AlertIcon className={className} />
  );
}
